import { render, staticRenderFns } from "./funnel-api.md?vue&type=template&id=7c4a8b8b&"
import script from "./funnel-api.md?vue&type=script&lang=js&"
export * from "./funnel-api.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4a8b8b')) {
      api.createRecord('7c4a8b8b', component.options)
    } else {
      api.reload('7c4a8b8b', component.options)
    }
    module.hot.accept("./funnel-api.md?vue&type=template&id=7c4a8b8b&", function () {
      api.rerender('7c4a8b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/funnel-api.md"
export default component.exports